import { Container, Flex, Text } from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import { generatePath } from 'react-router-dom';

import { LoadingState } from '../../components/file-browser';
import { ProblematicFilesContainer } from '../../components/problematic-files-container/problematic-files-container';
import * as Routes from '../../constants/routes';
import { useGetProblemFilesQuery } from '../../graphql/generated';
import { useProblematicFilesPageQueryParams } from '../../hooks/use-problematic-files-page-query-params/use-problematic-files-page-query-params';
import { DebounceLoadingState } from '../../ui/debounce-loading/debounce-loading';
import { ErrorState } from '../../ui/errors/error-state';

export const navigateToProlematicFilesPage = (): string => {
  const path = generatePath(Routes.PROBLEMATIC_FILES);
  return path;
};

export const ProblematicFilesPage = () => {
  const {
    params,
    setProblemTypeParam,
    setTreatyParam,
  } = useProblematicFilesPageQueryParams();
  const { error, loading, data, refetch } = useGetProblemFilesQuery({
    variables: { cedants: params?.treaties },
  });

  if (error) {
    return (
      <ErrorState
        title="An error occurred while searching for problematic files"
        subtitle="Please reach out to our technical support team for further assistance."
      />
    );
  }

  if (loading || !data) {
    return (
      <Flex flex="1" mt="4">
        <DebounceLoadingState>
          <LoadingState />
        </DebounceLoadingState>
      </Flex>
    );
  }

  const totalFileCount = data.problematicFiles.problematicFiles.reduce(
    (a, b) => {
      return a + b.count;
    },
    0
  );

  return (
    <>
      <Helmet>
        <title>Problematic Files</title>
      </Helmet>
      <Container p={8} maxW="100%" data-testid="problematic-files-container">
        <Flex flexDirection="row" justifyContent="space-between">
          <Flex justify="space-between" align="baseline" flexDirection="column">
            <Text textStyle="title" as="h1" mb={2}>
              Problematic Files
            </Text>
            <Text as="p" mb={4}>
              {' '}
              This page shows a list of files with processing and upload errors.{' '}
            </Text>
          </Flex>
          <Text
            color="gray.500"
            fontWeight="500"
            minWidth="24rem"
            data-testid="problematic-file-count"
            textAlign={{ sm: 'left', md: 'right' }}
          >
            Total problematic files found {totalFileCount}
          </Text>
        </Flex>
        <ProblematicFilesContainer
          treaties={data.problematicFiles.allowedDataRooms}
          problemTypeObjects={data.problematicFiles.problematicFiles}
          refetch={refetch}
          setProblemTypeParam={setProblemTypeParam}
          setTreatyParam={setTreatyParam}
          params={params}
        />
      </Container>
    </>
  );
};
